export default {
  state: {
    customer: null,
    business: null,
    locale: {
      country: 'us',
    },
    appVersion: 0,
  },
  getters: {
    isAuth: (state) => {
      return !!state.customer;
    },
    business: (state) => {
      return state.business;
    },
    customer: (state) => {
      return state.customer;
    },
    locale: (state) => {
      return state.locale;
    },
    appVersion: (state) => {
      return state.appVersion;
    },
    getCountry: (state) => {
      return state.locale.country;
    },
    businessUrlProfile: (state) => {
      return state.business ? state.business.url_profile : '';
    },
  },
  actions: {},
  mutations: {
    unsetAuth(state) {
      state.customer = null;
      state.business = null;
    },
    setBusiness(state, val) {
      state.business = val;
    },
    setCustomer(state, val) {
      state.customer = val;
    },
    setLocale(state, val) {
      state.locale = val;
    },
    setAppVersion(state, val) {
      state.appVersion = val;
    },
  },
};
